export default __webpack_public_path__ + "static/media/Astrana_Symbol_White.aea6a813.svg";